export const autocompleteTheme = {
  colorScheme: {
    light: {
      dropdown: {
        background: 'transparent',
        hoverBackground: 'transparent',
        activeBackground: 'transparent'
      }
    },
    dark: {
      dropdown: {
        background: 'transparent',
        hoverBackground: 'transparent',
        activeBackground: 'transparent'
      }
    }
  }
};
